<template>
  <div>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="params.id" placeholder="Id" clearable style="width:100px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.trans_id" placeholder="Business Trans Id" clearable style="width:200px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-cascader :options="country_business" size="small"
          :props="{ checkStrictly: true,value:'name',label:'name',expandTrigger: 'hover'}" clearable
          placeholder="Country/Business" @change="cascaderChange" style="position:relative;right:2px">
        </el-cascader>
      </el-form-item>
      <el-select size="small" v-model="params.operator_id" clearable placeholder="Country/Operator"
        style="width:160px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in trans_operator" :key="item.id" :label="item.country+' | '+item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.rob_user_id" clearable placeholder="Rob user"
        style="width:120px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in sms_user_list" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.type" clearable placeholder="Type"
        style="width:120px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in type_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.rob_type" clearable placeholder="Grab Type"
        style="width:120px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in rob_type_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-form-item label="">
        <el-input size="small" v-model="params.rob_user_name" placeholder="Rob user" clearable style="width:140px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.amount" placeholder="Amount" clearable style="width:100px">
        </el-input>
      </el-form-item>
      <el-select size="small" v-model="params.is_usd" clearable placeholder="Is it USD?"
        style="width:120px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in is_usd_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.transfer_to_agent" clearable placeholder="Transfer to agent?"
        style="width:120px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in transfer_to_agent_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-form-item label="">
        <el-input size="small" v-model="params.transaction_id" placeholder="Transaction Id" clearable
          style="width:140px">
        </el-input>
      </el-form-item>
      <el-select size="small" v-model="params.state" clearable placeholder="Status"
        style="width:140px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in state_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.is_top" clearable placeholder="Is top"
        style="width:120px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in is_top_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-form-item label="">
        <el-input size="small" v-model="params.paid_phone" placeholder="Paid phone" clearable style="width:140px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.paid_name" placeholder="Paid name" clearable style="width:140px">
        </el-input>
      </el-form-item>
      <el-select size="small" v-model="params.sort" clearable placeholder="Amount Sort"
        style="width:120px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in sort_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-form-item label="">
        <el-date-picker v-model="params.success_time" type="daterange" size="small" value-format="yyyy-MM-dd"
          align="right" unlink-panels start-placeholder="Start date(Success)" end-placeholder="End date(Success)"
          :picker-options="pickerOptions" clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="params.add_time" type="daterange" size="small" value-format="yyyy-MM-dd" align="right"
          unlink-panels start-placeholder="Start date(Add)" end-placeholder="End date(Add)"
          :picker-options="pickerOptions" clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button type="success" size="small" icon="el-icon-document" @click="exportExcel">Export</el-button>
        <el-button type="warning" size="small" icon="el-icon-plus" @click="handleEdit()">Add</el-button>
        <el-button type="danger" size="small" icon="el-icon-thumb" @click="batchAssign()">Batch Assign</el-button>
        <el-button type="danger" size="small" icon="el-icon-thumb" @click="batchUnlock()">Batch Unlock</el-button>
        <el-button type="warning" size="small" icon="el-icon-brush" @click="removeExceptional()">Remove Exceptional
        </el-button>
        <el-button type="danger" size="small" icon="el-icon-plus" @click="addSms()">Add sms</el-button>
        <!-- <el-button type="danger" size="small" icon="el-icon-thumb" @click="batchAssign()"
          v-if="dkh_user=='xqs'||dkh_user=='ken'||dkh_user=='coco'">Batch Assign</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 1672px;" @selection-change="batchAssignSelectionChange" :row-key="getRowKeys">
      <el-table-column type="selection" :reserve-selection="true" width="50" align="center"
        :selectable="checkSelectable">
      </el-table-column>
      <el-table-column prop="id" label="Id" width="80" align="center">
      </el-table-column>
      <el-table-column prop="amount" label="Amount" width="70">
        <template slot-scope="scope">
          <div>{{scope.row.amount}}</div>
          <div v-if="scope.row.is_usd==1" style="color:#F56C6C;font-weight: bold;">USD</div>
          <div v-if="scope.row.transfer_to_agent==1" style="color:#F56C6C;font-weight: bold;">Transfer to agent</div>
        </template>
      </el-table-column>
      <el-table-column prop="paid_phone" label="User" width="130">
        <template slot-scope="scope">
          <div>{{scope.row.paid_phone}}</div>
          <div>{{scope.row.paid_name}}</div>
          <div v-if="scope.row.operator">
            <div :style="{color:scope.row.operator_color, fontSize:'14px'}" v-if="scope.row.operator_color">
              {{scope.row.operator}}</div>
            <el-link type="primary" :underline="false" v-else>{{scope.row.operator}}</el-link>
          </div>
          <div v-if="scope.row.paid_bank">
            <el-link type="primary" :underline="false">{{scope.row.paid_bank}}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="rob_user_name" label="Grab" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.rob_user_name">
            <el-link type="warning" icon="el-icon-edit" :underline="false" @click="unlock(scope.row.id)">
              {{scope.row.rob_user_name}}</el-link>
            <div>{{scope.row.reward}}</div>
            <div>
              <el-link type="primary" :underline="false" v-if="scope.row.rob_type==1">Manual</el-link>
              <el-link type="success" :underline="false" v-if="scope.row.rob_type==2">Auto</el-link>
            </div>
          </div>
          <div v-else>
            <el-link type="danger" icon="el-icon-edit" :underline="false" @click="assignRobber(scope.row)">
              distribution</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="state" align="center" label="Status" width="100">
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" v-if="scope.row.state==1">To be paid</el-link>
          <el-link type="warning" :underline="false" v-if="scope.row.state==2">Confirmed</el-link>
          <el-link type="success" :underline="false" v-if="scope.row.state==3">Completed</el-link>
          <el-link type="danger" :underline="false" v-if="scope.row.state==4">Rejected</el-link>
          <el-link type="danger" :underline="false" v-if="scope.row.state==5">Locked</el-link>
          <el-link type="danger" :underline="false" v-if="scope.row.state==6">Refund</el-link>
          <el-link type="danger" :underline="false" v-if="scope.row.state==7">Exceptional</el-link>
          <div v-if="scope.row.state==4&&scope.row.rejected_man&&scope.row.rejected_man!='null'">
            {{scope.row.rejected_man}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="add_time" label="Time【1】" width="200">
        <template slot-scope="scope">
          <div><span style="color:#909399">Add：</span>{{scope.row.add_time|timestampToTime}}</div>
          <div v-if="scope.row.unlock_time"><span
              style="color:#909399">Unlock：</span>{{scope.row.unlock_time|timestampToTime}}</div>
          <div><span style="color:#909399">Lock：</span>{{scope.row.rob_time|timestampToTime}}</div>
          <div v-if="scope.row.rob_time_2"><span
              style="color:#909399">Lock2：</span>{{scope.row.rob_time_2|timestampToTime}}</div>
          <div><span style="color:#909399">Handle：</span>{{scope.row.pay_time|timeCal}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="add_time" label="Time【2】" width="210">
        <template slot-scope="scope">
          <div><span style="color:#909399">Call：</span>{{scope.row.call_time|timestampToTime}}</div>
          <div><span style="color:#909399">Confirm：</span>{{scope.row.confirm_time|timestampToTime}}</div>
          <div><span style="color:#909399">Success：</span>{{scope.row.success_time|timestampToTime}}</div>
          <div v-if="scope.row.rejected_time"><span
              style="color:#909399">Rejected：</span>{{scope.row.rejected_time|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="business_name" label="Business/Country" width="110">
        <template slot-scope="scope">
          <div>{{scope.row.business_name}}</div>
          <div>{{scope.row.country}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="trans_id" label="Trans id" width="110">
      </el-table-column>
      <el-table-column prop="transaction_id" label="Transaction Id" width="130">
      </el-table-column>
      <el-table-column prop="rejected_back_state" label="Reject callback" width="80">
        <template slot-scope="scope" v-if="scope.row.rejected_time">
          <el-link type="danger" :underline="false" v-if="scope.row.rejected_back_state==0">fail</el-link>
          <el-link type="primary" :underline="false" v-if="scope.row.rejected_back_state==1">success</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="type" align="center" label="Type/Top" width="100">
        <template slot-scope="scope">
          <div>
            <el-link type="success" :underline="false" v-if="scope.row.type==0">normal</el-link>
            <el-link type="primary" :underline="false" v-if="scope.row.type==1">kaka</el-link>
            <el-link type="warning" :underline="false" v-if="scope.row.type==2">withdrawal</el-link>
            <el-link type="danger" :underline="false" icon="el-icon-edit" v-if="scope.row.type==3&&scope.row.state==1"
              @click="assignRobber(scope.row)">same</el-link>
            <el-link type="danger" :underline="false" v-if="scope.row.type==3&&scope.row.state!=1"
              @click="assignRobber(scope.row)">same</el-link>
            <el-link type="warning" :underline="false" v-if="scope.row.type==4">make up</el-link>
          </div>
          <div>
            <el-link type="warning" icon="el-icon-edit" :underline="false" v-if="scope.row.is_top"
              @click="setTop(scope.row.id,0)">Yes</el-link>
            <el-link type="info" icon="el-icon-edit" :underline="false" v-else @click="setTop(scope.row.id,1)">No
            </el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Action" width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" @click="transRejected(scope.row)"
            v-if="scope.row.state!=3&&scope.row.state!=4&&scope.row.state!=6">reject</el-button>
          <el-button size="mini" type="primary" @click="rejectedCallback(scope.row)" v-if="scope.row.state==4">Reject
            detail
          </el-button>
          <el-button size="mini" type="success" @click="seeDetail(scope.row)"
            v-if="scope.row.state==2||scope.row.state==5||scope.row.state==7">success</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- successWithdraw界面 -->
    <el-dialog title="" :visible.sync="detailVisible" @click='closeDialog("detail")' width="40%">
      <el-descriptions title="Success Withdraw" :column="2" border style="padding-bottom:20px">
        <el-descriptions-item label="Amount">{{detail_info.amount}}</el-descriptions-item>
        <el-descriptions-item label="Grab人">{{detail_info.rob_user_name}}</el-descriptions-item>
        <el-descriptions-item label="Add time">{{detail_info.add_time|timestampToTime}}</el-descriptions-item>
        <el-descriptions-item label="Transaction Id" span="1">
          <el-input type="text" size="small" v-model="transaction_id" placeholder="输入Transaction Id" clearable>
          </el-input>
        </el-descriptions-item>
        <el-descriptions-item label="Fee" span="1">
          <el-input type="number" style="width:200px" size="small" v-model="fee" placeholder="输入Fee" clearable>
          </el-input>
        </el-descriptions-item>
        <el-descriptions-item label="Card Number" span="1">
          <el-select size="small" v-model="card_number" clearable placeholder="Card Number">
            <el-option v-for="item in buss_card" :key="item.id" :label="item.number+'【'+item.sms_user_name+'】'"
              :value="item.number">
            </el-option>
          </el-select>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <div style="font-size:12px;margin-bottom:10px;color:#F56C6C">(tips：After confirmation, the system will add a
          message and will automatically call back after 3 minutes.)</div>
        <el-button size="small" type="primary" :loading="loading" class="title"
          @click="transactionSucc(detail_info.id)">Confirm
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="APP User" :visible.sync="assignVisible" width="621px" @click='closeDialog("assign")'>
      <el-form :inline="true" class="user-search">
        <el-form-item label="">
          <el-input size="small" v-model="assign_name" placeholder="Rob user" clearable style="width:200px">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="assignSearch">Search</el-button>
        </el-form-item>
      </el-form>
      <el-table size="small" :data="sms_user_list_new" highlight-current-row v-loading="loading"
        element-loading-text="Loading..." style="width:681px">
        <el-table-column prop="sms_user_id" label="" width="80">
          <template slot-scope="scope">
            <el-radio v-model="assign_robber.rob_user_id" :label="scope.row.id"></el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Name" width="100">
        </el-table-column>
        <el-table-column prop="operator_name" label="Operator name" width="120">
        </el-table-column>
        <el-table-column prop="socket_id" label="online/offline" width="120" align="center">
          <template slot-scope="scope">
            <el-link type="danger" :underline="false" v-if="scope.row.socket_id==0">Offline</el-link>
            <el-link type="info" :underline="false" v-else>online</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="auto_trans" label="Automatic Withdraw" width="140">
          <template slot-scope="scope">
            <el-link type="info" :underline="false" v-if="scope.row.auto_trans==1">open</el-link>
            <el-link type="danger" :underline="false" v-else>close</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("assign")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitRobber">Save
        </el-button>
      </div>
    </el-dialog>
    <!-- Callback Details -->
    <el-dialog title="" :visible.sync="callbackVisible" @click='closeDialog("callback")' width="50%">
      <el-descriptions title="Callback Details" :column="2" border style="padding-bottom:20px">
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Callback URL" span="2">{{rejectedInfo.rejected_url}}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Callback Status" span="2">
          <el-link type="danger" :underline="false" v-if="rejectedInfo.rejected_back_state==0">fail
          </el-link>
          <el-link type="success" :underline="false" v-if="rejectedInfo.rejected_back_state==1">success
          </el-link>
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Callback Datas" :column="2">{
          "trans_id": "{{rejectedInfo.trans_id}}",
          "amount": "{{rejectedInfo.amount}}",
          "phone": "{{rejectedInfo.paid_phone}}",
          "name": "{{rejectedInfo.paid_name}}",
          "business_name": "{{rejectedInfo.business_name}}"
          }</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" :loading="loading" class="title" @click="callbackSubmit">Send callback
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="editFormVisible" width="35%" style="margin-left:300px"
      @click='closeDialog("edit")'>
      <el-form label-width="160px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="Country" prop="country">
          <el-select size="small" v-model="editForm.country" clearable placeholder="Country" @change="countryBlur">
            <el-option v-for="item in countryList" :key="item.currency" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Business" prop="business_id">
          <el-select size="small" v-model="editForm.business_id" clearable placeholder="Business"
            @change="businessBlur">
            <el-option v-for="item in country_business_list" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Amount" prop="amount">
          <el-input size="small" type="number" v-model="editForm.amount" auto-complete="off" placeholder="Amount"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Is it USD?" prop="is_usd">
          <el-radio-group v-model="editForm.is_usd">
            <el-radio :label="0">NO</el-radio>
            <el-radio :label="1">YES</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Transfer to agent?" prop="transfer_to_agent">
          <el-radio-group v-model="editForm.transfer_to_agent">
            <el-radio :label="0">NO</el-radio>
            <el-radio :label="1">YES</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Paid phone" prop="phone">
          <el-input size="small" type="number" v-model="editForm.phone" auto-complete="off"
            placeholder="User transfers 9-digit mobile phone number without 0/254 in front" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Card name" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="Card name" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Business trans_id" prop="trans_id">
          <el-input size="small" v-model="editForm.trans_id" auto-complete="off" placeholder="Business trans_id"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Grab" prop="rob_user_id">
          <el-select size="small" v-model="editForm.rob_user_id" clearable placeholder="Select grab">
            <el-option v-for="item in country_sms_user_list" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Type" prop="type">
          <el-select size="small" v-model="editForm.type" clearable placeholder="Select Type">
            <el-option v-for="item in type_list" :key="item.k" :label="item.v" :value="item.k">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">Save
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="batchVisible" @click='closeDialog("batch")' width="40%">
      <el-descriptions title="Batch Assign" :column="1" border style="padding-bottom:20px">
        <el-descriptions-item label="ID" span="1">{{batch_assign.transfers_ids.join(',')}}</el-descriptions-item>
        <el-descriptions-item label="App User Name" span="1">
          <el-input type="text" size="small" v-model="batch_assign.app_user_name" placeholder="App User Name" clearable>
          </el-input>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("batch")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="batchConfirm">Confirm
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    transactionList,
    transBusinessList,
    transRejected,
    countryList,
    transactionTop,
    getSmsUserList,
    transactionUnlock,
    transactionSucc,
    assignRobber,
    rejectedCallback,
    transactionSmsUser,
    transactionSave,
    countryBlur,
    businessBlur,
    getCountryBusiness,
    transOperator,
    transfersBatchAssign,
    transfersBatchUnlock,
    removeException,
    addSms,
    getBussCard
  } from '../../api/apiFun'
  import {
    timestampToTime,
    exportUrl,
    cascaderChange,
    getCookie
  } from '@/utils/util';
  import Pagination from '../../components/Pagination'
  let that = ""
  export default {
    data() {
      return {
        dkh_user: getCookie('dkh_user'),
        title: '',
        loading: false, //是显示加载
        examineVisible: false, //控制Edit页面显示与隐藏
        params: {
          page: 1,
          limit: 10,
          id: '',
          trans_id: '',
          transaction_id: '',
          paid_phone: '',
          paid_name: '',
          state: '',
          success_time: '',
          add_time: '',
          business_name: '',
          rob_user_id: '',
          amount: '',
          is_usd: '',
          transfer_to_agent: '',
          type: '',
          is_top: '',
          rob_user_name: '',
          country: '',
          rob_type: '',
          operator_id: '',
          sort: '',
        },
        robber_params: {
          name: '',
          country: '',
          business_name: '',
        },
        state_list: [{
          k: 1,
          v: 'To be paid'
        },
        {
          k: 2,
          v: 'Confirmed'
        },
        {
          k: 3,
          v: 'Completed'
        },
        {
          k: 4,
          v: 'Rejected'
        },
        {
          k: 5,
          v: 'Locked'
        },
        {
          k: 6,
          v: 'Refund'
        },
        {
          k: 7,
          v: 'Exceptional'
        },
        {
          k: 8,
          v: 'To be paid(Locked)'
        },
        ],
        type_list: [{
          k: 0,
          v: 'normal'
        },
        {
          k: 1,
          v: 'kaka'
        },
        {
          k: 2,
          v: 'withdrawal'
        },
        {
          k: 3,
          v: 'same'
        },
        {
          k: 4,
          v: 'make up'
        },
        ],
        rob_type_list: [{
          k: 1,
          v: 'Manual'
        },
        {
          k: 2,
          v: 'Auto'
        },
        ],
        is_usd_list: [{
          k: 0,
          v: 'NO'
        },
        {
          k: 1,
          v: 'YES'
        },
        ],
        transfer_to_agent_list: [{
          k: 0,
          v: 'NO'
        },
        {
          k: 1,
          v: 'YES'
        },
        ],
        is_top_list: [{
          k: 0,
          v: 'No'
        },
        {
          k: 1,
          v: 'Yes'
        },
        ],
        sort_list: [{
          k: 1,
          v: 'small to large'
        },
        {
          k: 2,
          v: 'large to small'
        },
        ],
        business_list: [],
        sms_user_list: [],
        sms_user_list_new: [],

        listData: [], //User数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        pickerOptions: {
          shortcuts: [{
            text: 'Today',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        detailVisible: false,
        detail_info: {},
        buss_card: [],
        transaction_id: '',
        fee: '',
        card_number: '',
        examineInfo: {},
        editFormVisible: false,
        editForm: {
          country: '',
          business_id: '',
          amount: '',
          is_usd: 0,
          transfer_to_agent: 0,
          phone: 0,
          trans_id: '',
          rob_user_id: '',
          type: '',
          name: '',
        },
        country_business_list: [],
        country_sms_user_list: [],
        rules: {
          country: [{
            required: true,
            message: 'Please select country',
            trigger: 'blur'
          }],
          business_id: [{
            required: true,
            message: 'Please select business',
            trigger: 'blur'
          }],
          amount: [{
            required: true,
            message: 'Please enter amount',
            trigger: 'blur'
          }],
          is_usd: [{
            required: true,
            message: 'Please select is_usd',
            trigger: 'blur'
          }],
          transfer_to_agent: [{
            required: true,
            message: 'Please select transfer_to_agent',
            trigger: 'blur'
          }],
          phone: [{
            required: true,
            message: 'Please enter phone number',
            trigger: 'blur'
          }],
          trans_id: [{
            required: true,
            message: 'Please enter business trans_id',
            trigger: 'blur'
          }],
          rob_user_id: [{
            required: true,
            message: 'Please select single person',
            trigger: 'blur'
          }],
          type: [{
            required: true,
            message: 'Please select type',
            trigger: 'blur'
          }],
          name: [{
            required: true,
            message: 'Please enter name',
            trigger: 'blur'
          }],
        },
        assign_robber: {
          id: 0,
          rob_user_id: 0,
          business_id: 0,
        },
        assign_name: '',
        assignVisible: false,
        countryList: [],
        callbackVisible: false,
        rejectedInfo: {},
        country_business: [],
        trans_operator: [],
        batch_assign: {
          app_user_name: '',
          transfers_ids: []
        },
        batchVisible: false,
        trans_operator_country: ''
      }
    },
    watch: {
      batchVisible(newValue) {
        if (newValue == false) {
          location.reload()
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    filters: {
      timestampToTime: function (timestamp) {
        return timestampToTime(timestamp)
      },
      transactionListstate: function (i) {
        var v = '';
        that.state_list.forEach(e => {
          if (e.k == i) {
            v = e.v
          }
        });
        return v
      },
      timeCal: function (runTime) {
        let day = Math.floor(runTime / 86400);
        runTime = runTime % 86400;
        let hour = Math.floor(runTime / 3600);
        runTime = runTime % 3600;
        let minute = Math.floor(runTime / 60);
        runTime = runTime % 60;
        let second = runTime;
        let str = '';
        if (day > 0) {
          str += day + ' Days ';
        }
        if (hour > 0) {
          str += hour + ' Hours ';
        }
        if (minute > 0) {
          str += minute + ' Minutes ';
        }
        if (second > 0) {
          str += second + ' Seconds ';
        }
        return str;
      }
    },
    created() {
      that = this
      this.getdata(this.params)
      this.transBusinessList()
      this.getSmsUserList()
      this.getCountryList()
      this.getCountryBusiness()
      this.transOperator()
    },
    methods: {
      addSms() {
        this.$confirm('确定要给已锁定订单添加短信吗?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          addSms({
            business_name: this.params.business_name,
            rob_user_id: this.params.rob_user_id,
            state: this.params.state,
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.datas
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.$message.error('Failed, please try again later!')
          })
        }).catch(() => {

        })
      },
      removeExceptional() {
        this.$confirm('确定要一键移除异常订单吗?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          removeException({
            country: this.params.country,
            business_name: this.params.business_name,
            state: this.params.state,
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'success！'
              })
              this.getdata(this.params)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.$message.error('Failed, please try again later!')
          })
        }).catch(() => {

        })
      },
      transOperator(country = '') {
        transOperator({
          country
        }).then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.trans_operator = res.datas;
          }
        }).catch(err => {
          this.$message.error('Failed to obtain trans_operator list, please try again later!')
        })
      },
      getCountryBusiness() {
        getCountryBusiness().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.country_business = res.datas;
          }
        }).catch(err => {
          this.$message.error('Failed to obtain business list, please try again later!')
        })
      },
      cascaderChange(value) {
        var cascader = cascaderChange(value)
        this.robber_params.country = this.params.country = cascader[0]
        this.robber_params.business_name = this.params.business_name = cascader[1]
        this.getSmsUserList()
        this.params.operator_id = ''
        console.log(cascader)
        if (!this.trans_operator_country) {
          this.trans_operator_country = cascader[0]
          this.transOperator(cascader[0]);
        } else {
          if (this.trans_operator_country != cascader[0] && cascader[0]) {
            this.trans_operator_country = cascader[0]
            this.transOperator(cascader[0]);
          }
        }
        if (!cascader[0] && !cascader[1]) {
          this.trans_operator_country = ''
          this.transOperator();
        }
      },
      businessBlur(business_id) {
        this.country_sms_user_list = [];
        this.editForm.rob_user_id = '';
        if (!business_id) {
          this.$message.error('Please select business')
          return
        }
        businessBlur({
          business_id: business_id
        }).then(res => {
          if (res.code == 200) {
            this.country_sms_user_list = res.datas.country_sms_user_list
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        }).catch(err => {
          this.$message.error('Failed to get country, please try again later!')
        })
      },
      countryBlur(country) {
        this.country_business_list = [];
        this.country_sms_user_list = [];
        this.editForm.business_id = '';
        this.editForm.rob_user_id = '';
        if (!country) {
          this.$message.error('Please select country')
          return
        }
        countryBlur({
          country: country
        }).then(res => {
          if (res.code == 200) {
            this.country_business_list = res.datas.country_business_list
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        }).catch(err => {
          this.$message.error('Failed to get country, please try again later!')
        })
      },
      submitForm(editData) {
        this.loading = true
        this.$refs[editData].validate(valid => {
          if (valid) {
            transactionSave(this.editForm).then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.getdata(this.params)
                this.$message({
                  type: 'success',
                  message: 'Saved successfully'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            }).catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('Saving failed, please try again later!')
            })
          } else {
            this.loading = false
            return false
          }
        })
      },
      //显示Edit界面
      handleEdit: function (index, row) {
        this.editFormVisible = true
        this.title = 'Add'
        this.editForm.business_id = ''
        this.editForm.amount = ''
        this.editForm.phone = ''
        this.editForm.trans_id = ''
        this.editForm.rob_user_id = ''
        this.editForm.type = ''
        this.editForm.name = ''
        this.editForm.country = ''
      },
      getRowKeys(row) {
        return row.id;
      },
      checkSelectable(row, index) {
        return row.state === 1 || row.state === 5 || row.state === 7
      },
      batchUnlock() {
        if (this.batch_assign.transfers_ids.length == 0) {
          this.$message.error('请勾选编号前面的选择框！')
          return
        }
        transfersBatchUnlock({ transfers_ids: this.batch_assign.transfers_ids }).then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
            this.batch_assign = {
              app_user_name: '',
              transfers_ids: []
            }
          } else {
            this.loading = false
            this.batchVisible = false;
            this.getdata(this.params)
            this.batch_assign = {
              app_user_name: '',
              transfers_ids: []
            }
          }
        }).catch(err => {
          this.batch_assign = {
            app_user_name: '',
            transfers_ids: []
          }
          this.$message.error('Failed to batch assign, please try again later!')
        })
      },
      batchAssignSelectionChange(val) {
        let transfers_ids = [];
        val.forEach(item => {
          transfers_ids.push(item.id)
        })
        this.batch_assign.transfers_ids = transfers_ids;
      },

      batchAssign() {
        if (this.batch_assign.transfers_ids.length == 0) {
          this.$message.error('请勾选编号前面的选择框！')
          return
        }
        this.batchVisible = true
      },
      batchConfirm() {
        if (!this.batch_assign.app_user_name) {
          this.$message.error('Please enter App User Name')
          return
        }
        this.loading = true
        transfersBatchAssign(this.batch_assign).then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
            this.batch_assign = {
              app_user_name: '',
              transfers_ids: []
            }
          } else {
            this.loading = false
            this.batchVisible = false;
            this.getdata(this.params)
            this.batch_assign = {
              app_user_name: '',
              transfers_ids: []
            }
          }
        }).catch(err => {
          this.batch_assign = {
            app_user_name: '',
            transfers_ids: []
          }
          this.$message.error('Failed to batch assign, please try again later!')
        })
      },
      assignSearch() {
        this.transactionUserList({
          id: this.assign_robber.id,
          name: this.assign_name,
          business_id: this.assign_robber.business_id
        });
      },
      assignRobber(row) {
        this.assign_name = '';
        this.assign_robber.id = row.id;
        this.assign_robber.business_id = row.business_id;
        this.transactionUserList({
          id: row.id,
          business_id: row.business_id
        });
        this.assignVisible = true
      },
      transactionUserList(params) {
        transactionSmsUser(params).then(res => {
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.sms_user_list_new = res.datas.list
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get SIM card list, please try again later!')
        })
      },
      transactionSucc(id) {
        if (!this.transaction_id) {
          this.$message.error('Please enter Transaction Id')
          return
        }
        this.loading = true
        transactionSucc({
          id: id,
          transaction_id: this.transaction_id,
          fee: this.fee,
          card_number: this.card_number
        }).then(res => {
          this.loading = false
          this.detailVisible = false
          if (res.code == 200) {
            this.getdata(this.params)
            this.$message({
              type: 'success',
              message: 'Successful withdrawal！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        }).catch(err => {
          this.detailVisible = false
          this.loading = false
          this.$message.error('Failed, please try again later!')
        })
      },
      rejectedCallback(row) {
        this.rejectedInfo = row
        this.callbackVisible = true
      },
      callbackSubmit() {
        this.loading = true
        rejectedCallback({
          id: this.rejectedInfo.id,
        }).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.callbackVisible = false
            this.getdata(this.params)
            this.$message({
              type: 'success',
              message: 'Send callback successfully'
            })
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to send callback, please try again later!')
        })
      },
      getCountryList() {
        countryList().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.countryList = res.datas
          }
        }).catch(err => {
          this.$message.error('Failed to get country, please try again later!')
        })
      },
      robberSearch() {
        this.getSmsUserList()
      },
      submitRobber() {
        if (!this.assign_robber.rob_user_id) {
          this.$message.error('Please choose single person')
          return
        }
        this.loading = true
        assignRobber(this.assign_robber).then(res => {
          this.loading = false
          this.assignVisible = false
          if (res.code == 200) {
            this.getdata(this.params)
            this.$message({
              type: 'success',
              message: 'success'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        }).catch(err => {
          this.assignVisible = false
          this.loading = false
          this.$message.error('Failed, please try again later!')
        })
      },
      unlock(id) {
        this.$confirm('Are you sure you want to cancel the order grabber?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          transactionUnlock({
            id,
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'success！'
              })
              this.getdata(this.params)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.$message.error('Failed, please try again later!')
          })
        }).catch(() => {

        })
      },
      setTop(id, is_top) {
        var t = is_top == 1 ? 'Are you sure you want to stick to the top?' : 'Are you sure you want to unpin？';
        this.$confirm(t, 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          transactionTop({
            id,
            is_top
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'Set upsuccess！'
              })
              this.getdata(this.params)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.$message.error('Failed, please try again later!')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'CancelledSet up'
          })
        })
      },
      seeDetail(detail_info) {
        if (detail_info.state == 3 || detail_info.state == 4) {
          this.$message.error('Cannot perform the operation！')
          return
        }
        this.detailVisible = true
        this.detail_info = detail_info
        getBussCard({ business_id: detail_info.business_id }).then(res => {
          this.buss_card = res.datas
        }).catch(err => {
          this.$message.error('Failed to obtain business card, please try again later!')
        })
      },
      transRejected(row) {
        if (row.state == 3 || row.state == 4) {
          this.$message.error('Cannot perform the operation！')
          return
        }
        this.$confirm('Are you sure you want to reject?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.loading = true
          transRejected({
            id: row.id
          }).then(res => {
            this.loading = false
            this.getdata(this.params)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'success'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('Failed, please try again later!')
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancelled reject'
          });
        });
      },
      exportExcel() {
        window.location.href = exportUrl('/admin/transaction/export_transaction', this.params);
      },
      closeDialog(type) {
        if (type == 'detail') {
          this.detailVisible = false
        }
        if (type == 'rejected') {
          this.rejectedVisible = false
        }
        if (type == 'callback') {
          this.callbackVisible = false
        }
        if (type == 'edit') {
          this.editFormVisible = false
        }
        if (type == 'batch') {
          this.batchVisible = false
        }
      },
      transBusinessList() {
        transBusinessList().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.business_list = res.datas.list
          }
        }).catch(err => {
          this.$message.error('Failed to obtain business list, please try again later!')
        })
      },
      getSmsUserList() {
        getSmsUserList(this.robber_params).then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.sms_user_list = res.datas.list
          }
        }).catch(err => {
          this.$message.error('Failed to get app user, please try again later!')
        })
      },
      // 获取Withdraw
      getdata(parameter) {
        if (parameter.success_time == null) {
          parameter.success_time = ''
        }
        this.loading = true
        transactionList(parameter).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.datas.list
            // 分页赋值
            this.pageparm.currentPage = this.params.page
            this.pageparm.pageSize = this.params.limit
            this.pageparm.total = res.datas.count
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get the withdraw list, please try again later!')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.params.page = parm.currentPage
        this.params.limit = parm.pageSize
        this.getdata(this.params)
      },
      // Search事件
      search() {
        this.params.page = 1
        this.getdata(this.params)
      },
    }
  }

</script>

<style scoped>
  .el-image__error {
    font-size: 12px !important;
  }

  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/views/transaction/transaction.vue